var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39473_46197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.5V0.5H0.5V25.5H25.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39473_46197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4477 3.52989C16.3455 3.76161 17.1937 4.11733 17.9725 4.57792C17.9725 4.57792 18.3477 4.20259 18.7691 3.78116C19.0751 3.47485 19.4904 3.30305 19.9232 3.30305C20.3556 3.30305 20.7709 3.47485 21.0769 3.78116C21.4481 4.15242 21.8593 4.5636 22.2305 4.93486C22.5369 5.24082 22.7086 5.65611 22.7086 6.08851C22.7086 6.52137 22.5369 6.93661 22.2305 7.24256C21.8091 7.664 21.4338 8.03927 21.4338 8.03927C21.8944 8.81805 22.2501 9.66615 22.4818 10.5641H23.6065C24.5077 10.5641 25.2383 11.2947 25.2383 12.1958V13.8276C25.2383 14.7287 24.5077 15.4594 23.6065 15.4594H22.4818C22.2501 16.3572 21.8944 17.2054 21.4338 17.9841C21.4338 17.9841 21.8091 18.3594 22.2305 18.7808C22.5369 19.0868 22.7086 19.5021 22.7086 19.9349C22.7086 20.3673 22.5369 20.7826 22.2305 21.0886C21.8593 21.4598 21.4481 21.871 21.0769 22.2422C20.7709 22.5486 20.3556 22.7203 19.9232 22.7203C19.4904 22.7203 19.0751 22.5486 18.7691 22.2422C18.3477 21.8208 17.9725 21.4455 17.9725 21.4455C17.1937 21.9061 16.3455 22.2618 15.4477 22.4935V23.6182C15.4477 24.5194 14.717 25.25 13.8159 25.25H12.1841C11.2829 25.25 10.5524 24.5194 10.5524 23.6182V22.4935C9.6545 22.2618 8.80635 21.9061 8.02757 21.4455C8.02757 21.4455 7.65229 21.8208 7.23086 22.2422C6.9249 22.5486 6.50961 22.7203 6.07681 22.7203C5.6444 22.7203 5.22906 22.5486 4.92316 22.2422C4.55195 21.871 4.14072 21.4598 3.76946 21.0886C3.46315 20.7826 3.29135 20.3673 3.29135 19.9349C3.29135 19.5021 3.46315 19.0868 3.76946 18.7808C4.19089 18.3594 4.56621 17.9841 4.56621 17.9841C4.10563 17.2054 3.74996 16.3572 3.51819 15.4594H2.39354C1.49237 15.4594 0.761734 14.7287 0.761734 13.8276V12.1958C0.761734 11.2947 1.49237 10.5641 2.39354 10.5641H3.51819C3.74996 9.66615 4.10563 8.81805 4.56621 8.03927C4.56621 8.03927 4.19089 7.664 3.76946 7.24256C3.46315 6.93661 3.29135 6.52137 3.29135 6.08851C3.29135 5.65611 3.46315 5.24082 3.76946 4.93486C4.14072 4.5636 4.55195 4.15242 4.92316 3.78116C5.22906 3.47485 5.6444 3.30305 6.07681 3.30305C6.50961 3.30305 6.9249 3.47485 7.23086 3.78116C7.65229 4.20259 8.02757 4.57792 8.02757 4.57792C8.80635 4.11733 9.6545 3.76161 10.5524 3.52989V2.40519C10.5524 1.50403 11.2829 0.773438 12.1841 0.773438H13.8159C14.717 0.773438 15.4477 1.50403 15.4477 2.40519V3.52989Z",
    stroke: "#008FC9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.11563C15.7018 8.11563 17.8953 10.3091 17.8953 13.0109C17.8953 15.7127 15.7018 17.9062 13 17.9062C10.2982 17.9062 8.10469 15.7127 8.10469 13.0109C8.10469 10.3091 10.2982 8.11563 13 8.11563Z",
    stroke: "#008FC9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.50ed2db034e3b9743861a2bf68f376c0.svg";
export { ForwardRef as ReactComponent };